export default [
    {
        path: "/service",
        name: "Service",
        component: require("@/components/Service/ServiceListPage").default,
        meta: {
            breadcrumbs: [
                {
                    name: "Service",
                },
            ]
        }
    },{
        path: "/service/create",
        name: "AddService",
        component: require("@/components/Service/ServiceCreationPage").default,
        meta: {
            breadcrumbs: [
                {
                    name: "Service",
                    path: '/service',
                    query: {
                        type: "All",
                        typeName:"All",
                        name: "",
                        category: "All",
                        categoryName: "All",
                        status: "",
                        itemPerPage: 10,
                        page: 1
                    }
                },
                {
                    name: "Buat Baru",
                }
            ]
        }
    },{
        path: "/service/:id",
        name: "ServiceDetail",
        component: require("@/components/Service/ServiceDetailPage").default,
        meta: {
            breadcrumbs: [
                {
                    name: "Service",
                    path: '/service',
                    query: {
                        serviceId: '',
                        vendorName: '',
                        createdAt: '',
                        createdBy: '',
                        status: '',
                        page: 1,
                        itemPerPage: 10,
                    }
                },
                {
                    name: "Detail Service",
                }
            ]
        },
        beforeEnter: (to, from, next) => {
            to.meta.breadcrumbs[1].name = to.query.code ? `Detail ${to.query.code}` : "Detail Service";
            next();
        }
    },

]


// WEBPACK FOOTER //
// ./src/router/service/index.js